import { render, staticRenderFns } from "./accountTree.vue?vue&type=template&id=b509bf1c&scoped=true"
import script from "./accountTree.vue?vue&type=script&lang=js"
export * from "./accountTree.vue?vue&type=script&lang=js"
import style0 from "./accountTree.vue?vue&type=style&index=0&id=b509bf1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b509bf1c",
  null
  
)

export default component.exports